import React from 'react';
import styles from './Form.module.scss';

export interface Props extends React.SelectHTMLAttributes<HTMLSelectElement> {
  inputRef?: any;
  error?: any;
}

export default function FormSelect({ inputRef, error, ...props }: Props) {
  return (
    <div
      className={`${styles.formSelect} ${error ? styles.formSelectError : ''}`}
    >
      <select ref={inputRef} {...props}>
        {props.children}
      </select>
      {error && <p className={styles.labelError}>{error}</p>}
    </div>
  );
}
